export interface IState {
  title: string;
  searchResult: ISearchResult;
  currentPage: number;
  endpoints: IEndpoints;
  hitsPerPage: number;
}

export interface ISearchResult {
  items: IYearObject[];
  totalItems: number;
  showingHits: number;
}
export interface IYearObject {
  year: string;
  items: IEvent[];
}
export interface IEvent {
  title: string;
  uri: string;
  imageUri: string;
  year: string;
}
export interface IEndpoints {
  searchUrl: string;
}

const deafultState: IState = {
  title: "",
  searchResult: {
    items: [],
    totalItems: 0,
    showingHits: 0,
  },
  currentPage: 0,
  endpoints: {
    searchUrl: "",
  },
  hitsPerPage: 0,
};

export default deafultState;
